import request from '@/utils/request'

export const pageList = (getData) => {
  return request({
    url: '/back/customer/pageListCustomers',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
